import { matchPath } from 'react-router-dom';
import type { ResolvedAppScope } from './appScope.types';
import type { EnterpriseWorkspace } from 'v5/api/enterprise/enterprise.api';
import { appRouting } from 'v5/core/routing/appRouting';
import { resolveActiveEnterpriseWorkspace } from 'v5/features/core/enterprise/resolveActiveEnterpriseWorkspace';

const workspacePathPattern = appRouting.org().workspace().pathPrefix();
const teamPathPattern = appRouting.org().workspace().team().pathPrefix();

/** Workspace slug from `/app/:app_id/w/:workspaceId/...`. */
export function workspaceSlugFromEnterprisePath(
  pathname: string
): string | undefined {
  const match = matchPath<{ workspaceId: string }>(pathname, {
    path: workspacePathPattern,
    exact: false
  });
  return match?.params.workspaceId;
}

/** Team slug from `/app/:app_id/w/:workspaceId/team/:teamId/...`. */
export function teamSlugFromEnterprisePath(
  pathname: string
): string | undefined {
  const match = matchPath<{ teamId: string }>(pathname, {
    path: teamPathPattern,
    exact: false
  });
  return match?.params.teamId;
}

/**
 * Resolves a concrete workspace slug for link generation (nav, breadcrumbs, redirects).
 * Route-matching templates may still use `:workspaceId`; links must not.
 */
export function resolveWorkspaceSlugForLinks(
  scope: ResolvedAppScope,
  pathname: string,
  workspaces: EnterpriseWorkspace[] | undefined
): string {
  if (scope.level === 'workspace' || scope.level === 'team') {
    return scope.workspaceSlug;
  }

  const fromPath = workspaceSlugFromEnterprisePath(pathname);
  if (fromPath) {
    return fromPath;
  }

  return resolveActiveEnterpriseWorkspace(workspaces, scope)
    .activeWorkspaceSlug;
}
